module.exports = __webpack_public_path__ + "img/ratings.2bd79cd9.png";